import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import style from './style.scss';

const CustomizedSelect = (props) => {
  const {
    data,
    value,
    label,
    className,
    onChange,
    hasError,
    errorMessage,
    isRequired,
    ...restProps
  } = props;
  const [isVisited, setIsVisited] = useState(false);
  const [isRequiredInternal, setIsRequiredInternal] = useState(false);

  const handleBlur = (e) => {
    setIsVisited(true);
    if (e.target.value) {
      setIsRequiredInternal(false);
    } else {
      setIsRequiredInternal(isRequired);
    }
  };

  return (
    <label className={cn({ 'has-value': true, required: (isVisited && isRequiredInternal) || hasError })}>
      <span>
        {label}
        {
          ((isVisited && isRequired) || hasError) && <em>Required</em>
        }
        {
          isVisited && !isRequired && !hasError && <em>Optional</em>
        }
      </span>
      <select
        onChange={onChange}
        onBlur={handleBlur}
        className={style.select}
        value={value}
        {...restProps}
      >
        <option value="" defaultValue>Select...</option>
        {data.map((item) => <option key={item.value} value={item.value}>{item.title}</option>)}
      </select>
      <div className={style.error}>{errorMessage !== 'The input field is required' && errorMessage}</div>
    </label>
  );
};

CustomizedSelect.propTypes = {
  className: PropTypes.string,
  data: PropTypes.array.isRequired,
  hasError: PropTypes.bool,
  errorMessage: PropTypes.string,
  label: PropTypes.node,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  isRequired: PropTypes.bool,
};

CustomizedSelect.defaultProps = {
  className: '',
  hasError: false,
  errorMessage: '',
  label: null,
  name: '',
  value: '',
  isRequired: false,
};

export default CustomizedSelect;
